import {
  registerRenderer,
  getRenderer,
  hasRenderer,
  getRegisteredRendererNames,
  getRegisteredRenderers
} from './rendererRegister';

import baseRenderer from './_cellDecorator';
import autocompleteRenderer from './autocompleteRenderer';
import checkboxRenderer from './checkboxRenderer';
import htmlRenderer from './htmlRenderer';
import numericRenderer from './numericRenderer';
import passwordRenderer from './passwordRenderer';
import textRenderer from './textRenderer';

registerRenderer('base', baseRenderer);
registerRenderer('autocomplete', autocompleteRenderer);
registerRenderer('checkbox', checkboxRenderer);
registerRenderer('html', htmlRenderer);
registerRenderer('numeric', numericRenderer);
registerRenderer('password', passwordRenderer);
registerRenderer('text', textRenderer);

export {
  registerRenderer,
  getRenderer,
  hasRenderer,
  getRegisteredRendererNames,
  getRegisteredRenderers
};
